import {
  SET_PRODUCT_DEPOT_INFOS,
  UPDATE_PRODUCT_DEPOT_INFOS,
} from '../actionTypes';
import {IFarmInputProductDepotInfo} from 'constants/interfaces';

const initialState: IFarmInputProductDepotInfo[] = [];

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_PRODUCT_DEPOT_INFOS: {
      const productDepotInfos: IFarmInputProductDepotInfo[] =
        action.payload || [];
      return productDepotInfos.map((productDepotInfo) => ({
        ...productDepotInfo,
      }));
    }

    case UPDATE_PRODUCT_DEPOT_INFOS: {
      const updates: IFarmInputProductDepotInfo[] = action.payload;
      if (!updates) return state;

      return state.map((productDepotInfo) => {
        const update = updates.find((item) => item.id === productDepotInfo.id);
        if (update) return {...update};
        return productDepotInfo;
      });
    }

    default:
      return state;
  }
}
